import React from 'react';

/**
 * Kit radio — token-styled native input with an optional label + hint line.
 * RTL-safe. Touch-safe label hit area. Mirrors Checkbox's API.
 *
 * <Radio name="x" checked={...} onChange={...} label={t('...')} hint={t('...')} />
 */
const DOT =
  'h-4 w-4 shrink-0 border-edge-strong text-accent bg-surface ' +
  'focus:ring-2 focus:ring-ring focus:ring-offset-0 disabled:opacity-50 cursor-pointer';

const Radio = React.forwardRef(function Radio(
  { label, hint, className = '', labelClassName = '', disabled, ...rest },
  ref
) {
  const input = (
    <input type="radio" ref={ref} disabled={disabled} className={`${DOT} ${className}`} {...rest} />
  );
  if (!label) return input;
  return (
    <label
      className={`flex flex-col gap-0.5 min-h-[40px] justify-center select-none ${
        disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
      } ${labelClassName}`}
    >
      <span className="inline-flex items-center gap-2">
        {input}
        <span className="text-sm text-content-secondary">{label}</span>
      </span>
      {hint && <span className="text-xs text-content-muted ms-6">{hint}</span>}
    </label>
  );
});

export default Radio;
